export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create.vue?vue&type=template&id=702cd97e"


//////////////////
// WEBPACK FOOTER
// ./src/components/content/strings/create.vue?vue&type=template&id=702cd97e
// module id = Szs9
// module chunks = 0